var _style, _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCranberries({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 212.6 212.6",
    style: {
      enableBackground: "new 0 0 212.6 212.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4A38B;}\n\t.st1{fill:#E51E37;}\n\t.st2{fill:#F28F80;}\n\t.st3{fill:#A91B27;}\n\t.st4{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.63,182.83c42.69,0,77.3-34.29,77.3-76.6c0-42.3-34.61-76.6-77.3-76.6s-77.3,34.29-77.3,76.6 C29.33,148.54,63.94,182.83,106.63,182.83"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M108.58,142.14c20.13-1.44,35.29-18.94,33.84-39.07c-1.44-20.13-18.94-35.29-39.07-33.84 c-20.13,1.44-35.29,18.94-33.84,39.07C70.95,128.44,88.45,143.59,108.58,142.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.58,145.99c5.6,2,11.47,2.8,17.45,2.37c11.4-0.82,21.8-6.03,29.28-14.67c7.48-8.64,11.15-19.68,10.34-31.07 c-1.21-16.92-12.32-31.54-28.29-37.25c-5.6-2-11.48-2.8-17.45-2.37c-11.4,0.82-21.8,6.03-29.28,14.67 c-7.48,8.64-11.15,19.68-10.34,31.08C64.5,125.66,75.6,140.28,91.58,145.99z M83.05,85.84c5.3-6.12,12.67-9.81,20.74-10.39 c4.24-0.3,8.4,0.26,12.36,1.67c11.32,4.05,19.18,14.4,20.04,26.39c0.58,8.07-2.02,15.89-7.32,22.01 c-5.3,6.12-12.67,9.81-20.74,10.39c-4.24,0.31-8.4-0.26-12.36-1.68c-11.32-4.05-19.18-14.4-20.05-26.38 C75.15,99.78,77.75,91.96,83.05,85.84z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M85.38,110.81c0.1,0.09,0.14,0.24,0.08,0.37c-1.09,2.55-0.44,5.37,1.65,7.19c2.09,1.82,4.97,2.08,7.35,0.65 c0.12-0.07,0.27-0.06,0.37,0.03c2.09,1.82,4.97,2.08,7.35,0.65c2.38-1.42,3.51-4.09,2.89-6.79c-0.03-0.13,0.03-0.27,0.15-0.34 c2.38-1.42,3.51-4.09,2.89-6.79c-0.62-2.7-2.8-4.6-5.57-4.85c-0.14-0.01-0.25-0.11-0.28-0.25c-0.49-2.15-1.98-3.79-3.95-4.5 c-0.51-0.18-1.05-0.3-1.61-0.35c-2.76-0.25-5.25,1.24-6.33,3.79c-0.05,0.13-0.18,0.21-0.32,0.19c0,0,0,0,0,0 c-2.76-0.25-5.25,1.24-6.33,3.79C82.64,106.17,83.29,108.99,85.38,110.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M89.53,105.77c2.72,0.24,5.26-1.28,6.33-3.79c0.04-0.09,0.09-0.21,0.32-0.19c0.23,0.03,0.26,0.15,0.28,0.25 c0.49,2.13,2.01,3.8,4,4.51c0.5,0.18,1.02,0.29,1.57,0.34c0.1,0.01,0.23,0.02,0.28,0.25c0.05,0.23-0.06,0.3-0.15,0.35 c-2.34,1.4-3.5,4.13-2.89,6.79c0.02,0.1,0.05,0.23-0.15,0.35c-0.2,0.12-0.3,0.03-0.37-0.03c-2.06-1.8-5.01-2.06-7.35-0.66 c-0.08,0.05-0.2,0.12-0.37-0.03c-0.18-0.15-0.12-0.28-0.08-0.37c1.07-2.51,0.41-5.4-1.65-7.2c-0.07-0.06-0.18-0.15-0.08-0.37 C89.3,105.74,89.44,105.76,89.53,105.77z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M77.75,119.26c0,0-0.19,0.13-0.45,0.29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCranberries);
export default __webpack_public_path__ + "static/media/Cranberries.0ca84af24b937bad249cf884116d471b.svg";
export { ForwardRef as ReactComponent };